type UnsetFilter = 'any'

export type OrderStatus = UnsetFilter | "current" | "-3" | "-2" | "-1" | "0" | "1" | "2" | "3" | "4"
export const isOrderStatus = (value:string): value is OrderStatus => value == 'any'
	|| value == "current"
	|| value == "-3"
	|| value == "-2"
	|| value == "-1"
	|| value == "0"
	|| value == "1"
	|| value == "2"
	|| value == "3"
	|| value == "4"

export type PaidStatus =  UnsetFilter | "pending" | "paid"
export const isPaidStatus = (value:string): value is PaidStatus => value == 'any'
	|| value == "pending"
	|| value == "paid"

export type PaymentMethod = UnsetFilter | keyof PaymentMethods
export type PaymentMethods = {[paymentMethodId: string]: string}

export type Origin = UnsetFilter | keyof Origins
export type Origins = {[originId: string]: string}

export type GeoState = UnsetFilter | keyof GeoStates
export type GeoStates = {[stateId: string]: string}

export type PaymentGroup = UnsetFilter | keyof PaymentGroups
export type PaymentGroups = {[paymentGroupId: string]: string}

export type DateType = UnsetFilter | "submittedDate" | "processedDate" | "paymentReceivedDate"
export const isDateType = (value:string): value is DateType => value == 'any'
	|| value == 'submittedDate'
	|| value == "processedDate"
	|| value == "paymentReceivedDate"



// WEBPACK FOOTER //
// ./src/orders2/orders-filters/data.ts